import { useStoreState } from '@seller-hermes/hooks/easy-peasy';
import {
  getSellerGroupFeatureFlag,
  useSellerGroupFeatureFlag,
} from '@seller-hermes/hooks/useSellerGroupFeatureFlag';
import { UserTypeEnum } from '@seller-hermes/features/users/users.types';
import type { SellerGroupUser } from '@seller-hermes/features/seller-group';

/**
 * Workflow editor está acessível para:
 *  - usuários INTERNAL (time Abbiamo)
 *  - QUALQUER usuário cujo seller group tem a feature flag `workflows_visible` ativa
 */
export const canAccessWorkflows = (user?: SellerGroupUser | null): boolean => {
  if (!user) return false;
  if (user.type === UserTypeEnum.INTERNAL) return true;
  return Boolean(getSellerGroupFeatureFlag('workflows_visible', user));
};

export const useCanAccessWorkflows = (): boolean => {
  const userType = useStoreState((s) => s.login.sellerGroupUser?.type);
  const flag = useSellerGroupFeatureFlag('workflows_visible');
  if (userType === UserTypeEnum.INTERNAL) return true;
  return Boolean(flag);
};

export default useCanAccessWorkflows;
